import { render, staticRenderFns } from "./DialogAttachments.vue?vue&type=template&id=4858f76b"
import script from "./DialogAttachments.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogAttachments.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports